<script setup lang="ts">
const {
  subtotal,
  shippingCosts,
  totalPrice,
  totalProductDiscount,
} = useCart();

const finalShippingCost = computed(() => {
  return shippingCosts.value?.reduce((sum, cost) => {
    return sum + (cost.shippingCosts?.totalPrice || 0);
  }, 0);
});
</script>

<template>
  <ul class="space-y-1 text-sm">
    <SharedTransition>
      <li v-if="totalProductDiscount" class="flex justify-between">
        <span>{{ $t("cart.discount") }}</span>
        <SharedPrice :price="-Math.abs(totalProductDiscount)" />
      </li>
    </SharedTransition>
    
    <li class="flex justify-between">
      <span>{{ $t("cart.subtotal") }}</span>
      <SharedPrice :price="subtotal" />
    </li>

    <li class="flex justify-between">
      <span>{{ $t("cart.shippingEstimate") }}</span>
      <SharedPrice :price="finalShippingCost" />
    </li>

    <br />

    <li class="flex justify-between font-semibold">
      <span>{{ $t("cart.orderTotal") }}</span>
      <SharedPrice :price="totalPrice" />
    </li>
  </ul>
</template>
